export default "__VITE_ASSET__i1K3xfXW__"